import classNames from 'classnames';
import React, { Component } from 'react';

export interface HorizontalScrollAreaState {
  /**
   * 左スクロールのボタンを表示するかどうか
   */
  showPrevButton: boolean;

  /**
   * 右スクロールのボタンを表示するかどうか
   */
  showNextButton: boolean;

  /**
   * 横スクロールが発生するかどうか
   */
  hasScroll: boolean;
}

export interface HorizontalScrollAreaProps extends React.HTMLAttributes<HTMLElement> {
}

export default class HorizontalScrollArea extends Component<HorizontalScrollAreaProps, HorizontalScrollAreaState> {
  private scrollRef: React.RefObject<HTMLDivElement>
  private scrollInnerRef: React.RefObject<HTMLDivElement>

  constructor(props: HorizontalScrollAreaProps) {
    super(props);

    this.state = {
      showPrevButton: true,
      showNextButton: true,
      hasScroll: true,
    }

    this.scrollRef = React.createRef<HTMLDivElement>();
    this.scrollInnerRef = React.createRef<HTMLDivElement>();

    this.onWindowResize = this.onWindowResize.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onClickNextButton = this.onClickNextButton.bind(this);
    this.onClickPrevButton = this.onClickPrevButton.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.onWindowResize);

    this.onWindowResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  }

  /**
   * ウィンドウがリサイズしたときに呼ばれる
   * サイズが変わる可能性があるため、hasScrollを更新する
   */
  onWindowResize() {
    const scroll = this.scrollRef.current; // this.refs.scroll as HTMLElement;
    const scroll_inner = this.scrollInnerRef.current; // this.refs.scroll_inner as HTMLElement;

    if (!scroll || !scroll_inner) return;

    this.setState({
      hasScroll: scroll.clientWidth <= scroll_inner.clientWidth
    })

    this.onScroll();
  }

  /**
   * スクロールした時に、右側フェードを表示するかどうかを判定する
   */
  onScroll() {
    const { hasScroll } = this.state;
    const scroll = this.scrollRef.current; // this.refs.scroll as HTMLElement;

    if (!scroll) return;

    const { scrollLeft, clientWidth, scrollWidth } = scroll;

    this.setState({
      showPrevButton: scrollLeft !== 0,
      showNextButton: scrollLeft + clientWidth !== scrollWidth && hasScroll,
    });
  }

  onClickNextButton () {
    const scroll = this.scrollRef.current; // this.refs.scroll as HTMLElement;

    if (!scroll) return;

    const { scrollLeft, clientWidth } = scroll;

    scroll.scrollLeft = scrollLeft + clientWidth;
  }

  onClickPrevButton () {
    const scroll = this.scrollRef.current; // this.refs.scroll as HTMLElement;

    if (!scroll) return;

    const { scrollLeft, clientWidth } = scroll;

    scroll.scrollLeft = scrollLeft - clientWidth;
  }

  render() {
    const { hasScroll, showPrevButton, showNextButton } = this.state;
    const {
      children,
      className,
    } = this.props;
    const classes = classNames(
      "uc-carousel",
      className
    )

    return <div className={classes}>
      {hasScroll && showPrevButton && 
        <button className="uc-carousel__control uc-carousel__control--prev" onClick={this.onClickPrevButton}>
          <i className="uc-carousel-control-prev-icon material-icons">keyboard_arrow_left</i>
        </button>}
        <div style={{ overflowX: "auto" }} ref={this.scrollRef} onScroll={this.onScroll}>
          <div className="u-w-full" style={{ display: "inline-block" }} ref={this.scrollInnerRef}>
            {children}
          </div>
        </div>
      {hasScroll && showNextButton && 
        <button className="uc-carousel__control uc-carousel__control--next" onClick={this.onClickNextButton}>
          <i className="uc-carousel-control-next-icon material-icons">keyboard_arrow_right</i>
        </button>}
    </div>;
  }
}